import { watch } from "vue";

const noBottomNavNameList = ["reports-id", "brief-id", "plans", "plans-id"];
const route = useRoute();
const router = useRouter();
const pageStore = usePageStore();

export const useSnWatchRoute = () => {
  watch(
    () => route.path,
    () => {
      if (!!route.name) {
        pageStore.setBottomNav(
          !noBottomNavNameList.includes(route.name as string)
        );
      }
      setupItemBasedOnRoute();
    },
    { immediate: true }
  );
};

const setupItemBasedOnRoute = () => {
  for (let index = 0; index < pageStore.finalNavigationItems.length; index++) {
    const item = pageStore.finalNavigationItems[index];

    if (item.children) {
      for (let i = 0; i < item.children.length; i++) {
        const child = item.children[i];
        const path = router.resolve(child.to).path;
        if (path === route.path) {
          pageStore.setSelectedChild(i);
          pageStore.setSelectedItem(index);
          item.isOpen = true;
          return;
        }
      }
    } else {
      const path = router.resolve(item.to).path;
      if (path === route.path) {
        pageStore.setSelectedItem(index);
        return;
      }
    }
  }
};
